import config from '@services/config.js';
const { questionUrl, myOrderUrl, emallUrl, privateMallUrl, vwebsiteUrl } = config;
export default [
	{
		path: '/',
		redirect: { name: 'user.selfcenter' },
		component: () => import('@/views/home.vue'),
		name: 'backManage',
		title: '管理后台',
		type: 'home',
		meta: {
			crumb: '管理后台',
			title: '管理后台',
		},
		children: [
			{
				path: '/package',
				component: () => import('@/views/user/package.vue'),
				name: 'user.selfcenter',
				class: 'icon-a-1gerenzhongxin',
				crumb: '个人中心',
				companyCrumb: '企业概况',
				title: '个人中心',
				companyTitle: '企业概况',
				meta: {
					// code: 2,
					crumb: '个人中心',
					companyCrumb: '企业概况',
					title: '个人中心',
					companyTitle: '企业概况',
				},
			},
			{
				path: '/liveMode',
				name: 'user.liveMode',
				class: 'icon-a-2zhibo',
				title: '直播',
				redirect: { name: 'user.live' },
				component: () => import('@/views/user/liveMode'),
				meta: {
					code: 3,
					title: '直播',
					crumb: '直播',
				},
				children: [
					{
						group: 'live',
						path: '/live',
						component: () => import('@/views/user/myLive.vue'),
						class: 'icon-mylive',
						name: 'user.live',
						crumb: '直播列表',
						initName: 'live',
						title: '我的直播',
						meta: {
							code: 20,
							title: '我的直播',
							crumb: '直播列表',
						},
					},
					{
						group: 'live',
						path: '/liveCollection',
						component: () => import('@/views/user/liveCollection.vue'),
						class: 'icon-heji',
						name: 'user.myAlbum',
						crumb: '直播合集',
						title: '直播合集',
						meta: {
							code: 21,
							title: '直播合集',
							crumb: '直播合集',
						},
					},
					// {
					// 	group: 'live',
					// 	path: '/portal',
					// 	component: () => import('@/views/user/portalList.vue'),
					// 	name: 'user.portal',
					// 	class: 'icon-zhibojianzhan',
					// 	crumb: '直播建站',
					// 	title: '直播建站',
					// 	meta: {
					// 		code: 22,
					// 		title: '直播建站',
					// 		crumb: '直播建站',
					// 	},
					// },
					{
						group: 'live',
						path: '/distribute',
						component: () => import('@/views/user/distribute.vue'),
						name: 'user.distribute',
						class: 'icon-zhibojianzhan',
						crumb: '多媒体分发',
						title: '多媒体分发',
						meta: {
							title: '多媒体分发',
							crumb: '多媒体分发',
						},
					},
					// {
					// 	path: '/vwebsite',
					// 	class: 'icon-a-8shangcheng',
					// 	name: 'user.vwebsite',
					// 	crumb: '专题微站',
					// 	title: '专题微站',
					// 	link: vwebsiteUrl,
					// 	line: true,
					// 	isNew: true,
					// 	meta: {
					// 		title: '专题微站',
					// 		crumb: '专题微站',
					// 	},
					// },
				],
			},
			// {
			// 	path: '/shortlink',
			// 	component: () => import('@/views/user/shortlink'),
			// 	class: 'icon-lianjie',
			// 	crumb: '短链管理',
			// 	name: 'user.shortlink',
			// 	title: '短链管理',
			// 	line: true,
			// 	freeLimited: true,
			// 	meta: {
			// 		title: '短链管理',
			// 		crumb: '短链管理',
			// 	},
			// },
			{
				path: '/materialLibrary',
				component: () => import('@/views/user/materialLibrary'),
				class: 'icon-a-3meitiku',
				crumb: '媒体库',
				name: 'user.material',
				title: '媒体库',
				line: true,
				meta: {
					code: 4,
					title: '媒体库',
					crumb: '媒体库',
				},
				children: [
					{
						group: 'library',
						path: '/materialLibrary',
						name: 'user.material.video',
						class: '',
						crumb: '视频库',
						title: '视频库',

						meta: {
							code: 30,
							crumb: '媒体库',
							title: '媒体库',
						},
						queryData: {
							name: '2',
						},
					},
					{
						group: 'library',
						path: '/materialLibrary',
						name: 'user.material.source',
						class: '',
						crumb: '素材库',
						title: '素材库',
						meta: {
							code: 31,
							crumb: '媒体库',
							title: '媒体库',
						},
						queryData: {
							name: '0',
						},
					},
					{
						group: 'library',
						path: '/materialLibrary',
						name: 'user.material.tuwen',
						class: '',
						crumb: '图文直播',
						title: '图文直播',
						meta: {
							code: 32,
							crumb: '媒体库',
							title: '媒体库',
						},
						queryData: {
							name: '4',
						},
					},
					{
						group: 'library',
						path: '/materialLibrary',
						name: 'user.material.water',
						class: '',
						crumb: '直播水印',
						title: '直播水印',
						meta: {
							code: 33,
							crumb: '媒体库',
							title: '媒体库',
						},
						queryData: {
							name: '3',
						},
					},
				],
			},
			{
				path: '/marketing',
				component: () => import('@/views/user/marketing.vue'),
				class: 'icon-a-4yingxiaozhongxin',
				name: 'user.marketing',
				crumb: '营销中心',
				title: '营销中心',
				meta: {
					code: 5,
					title: '营销中心',
					crumb: '营销中心',
				},
			},
			// {
			// 	path: '/marketing/micro',
			// 	name: 'user.marketing.micro',
			// 	component: () => import('@/views/user/marketing/micro.vue'),
			// 	title: '微网站',
			// 	crumb: '微网站',
			// 	hidden: true,
			// 	meta: {
			// 		parentName: 'user.marketing',
			// 		title: '微网站',
			// 		crumb: '微网站',
			// 	},
			// },
			{
				path: '/marketing/promoter',
				name: 'user.marketing.promoter',
				component: () => import('@/views/user/marketing/promoter.vue'),
				title: '推广员',
				crumb: '推广员',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '推广员',
					crumb: '推广员',
				},
			},
			{
				path: '/marketing/invitefree',
				name: 'user.marketing.invitefree',
				component: () => import('@/views/user/marketing/invitefree.vue'),
				title: '邀请好友免单',
				crumb: '邀请好友免单',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '邀请好友免单',
					crumb: '邀请好友免单',
				},
			},
			{
				path: '/marketing/invitereward',
				name: 'user.marketing.invitereward',
				component: () => import('@/views/user/marketing/invitereward.vue'),
				title: '邀请奖励',
				crumb: '邀请奖励',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '邀请奖励',
					crumb: '邀请奖励',
				},
			},
			{
				path: '/marketing/watchreward',
				name: 'user.marketing.watchreward',
				component: () => import('@/views/user/marketing/watchreward.vue'),
				title: '观看有奖',
				crumb: '观看有奖',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '观看有奖',
					crumb: '观看有奖',
				},
			},
			{
				path: '/marketing/signin',
				name: 'user.marketing.signin',
				component: () => import('@/views/user/marketing/signin.vue'),
				title: '签到',
				crumb: '签到',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '签到',
					crumb: '签到',
				},
			},
			{
				path: '/marketing/redrain',
				name: 'user.marketing.redrain',
				component: () => import('@/views/user/marketing/redrain.vue'),
				title: '红包雨',
				crumb: '红包雨',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '红包雨',
					crumb: '红包雨',
				},
			},
			{
				path: '/marketing/vote',
				name: 'user.marketing.vote',
				component: () => import('@/views/user/marketing/vote.vue'),
				title: '投票',
				crumb: '投票',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '投票',
					crumb: '投票',
				},
			},
			{
				path: '/marketing/turntable',
				name: 'user.marketing.turntable',
				component: () => import('@/views/user/marketing/turntable.vue'),
				title: '转盘抽奖',
				crumb: '转盘抽奖',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '转盘抽奖',
					crumb: '转盘抽奖',
				},
			},
			{
				path: '/marketing/prizequiz',
				name: 'user.marketing.prizequiz',
				component: () => import('@/views/user/marketing/prizequiz.vue'),
				title: '有奖答题',
				crumb: '有奖答题',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '有奖答题',
					crumb: '有奖答题',
				},
			},
			{
				path: '/marketing/privatemall',
				name: 'user.marketing.privatemall',
				component: () => import('@/views/user/marketing/privatemall.vue'),
				title: '有奖答题',
				crumb: '有奖答题',
				hidden: true,
			},
			{
				path: '/marketing/blindBox',
				name: 'user.marketing.blindBox',
				component: () => import('@/views/user/marketing/blindBox.vue'),
				title: '盲盒',
				crumb: '盲盒',
				hidden: true,
			},
			{
				path: '/marketing/coupon',
				name: 'user.marketing.coupon',
				component: () => import('@/views/user/marketing/coupon.vue'),
				title: '商品优惠券',
				crumb: '商品优惠券',
				hidden: true,
			},
			{
				path: '/marketing/flashsale',
				name: 'user.marketing.flashsale',
				component: () => import('@/views/user/marketing/flashsale.vue'),
				title: '秒杀活动',
				crumb: '秒杀活动',
				hidden: true,
			},
			{
				path: '/marketing/group',
				name: 'user.marketing.group',
				component: () => import('@/views/user/marketing/group.vue'),
				title: '多人拼团',
				crumb: '多人拼团',
				hidden: true,
			},
			{
				path: '/marketing/onlinedraw',
				name: 'user.marketing.onlinedraw',
				component: () => import('@/views/user/marketing/onlinedraw.vue'),
				title: '在线抽奖',
				crumb: '在线抽奖',
				hidden: true,
			},
			{
				path: '/marketing/luckdraw',
				name: 'user.marketing.luckdraw',
				component: () => import('@/views/user/marketing/luckdraw.vue'),
				title: '幸运抽奖',
				crumb: '幸运抽奖',
				hidden: true,
			},
			{
				path: '/promoter',
				component: () => import('@/views/user/promoter/index.vue'),
				name: 'user.promoter',
				class: 'icon-lujing',
				crumb: '推广员',
				title: '推广员',
				meta: {
					title: '推广员',
					crumb: '推广员',
					parentName: 'companyManage',
				},
				hidden: true,
				redirect: { name: 'user.real-promoter' },
				children: [
					{
						path: 'index',
						name: 'user.real-promoter',
						meta: {
							title: '推广员',
							crumb: '推广员',
							parentName: 'companyManage',
						},
						component: () => import('@/views/user/promoter/promotion.vue'),
					},
					{
						path: 'promoter-detail/:id',
						component: () => import('@/views/user/promoter/promoter-detail.vue'),
						name: 'user.promoter-detail',
						hidden: true,
						meta: {
							title: '推广员',
							crumb: '推广员',
							parentName: 'companyManage',
						},
					},
				],
			},
			// {
			// 	path: '/userCenter',
			// 	component: () => import('@/views/user/userCenter'),
			// 	class: 'icon-a-5yonghuzhongxin',
			// 	name: 'user.userCenter',
			// 	crumb: '用户中心',
			// 	title: '用户中心',

			// 	meta: {
			// 		code: 6,
			// 		crumb: '用户中心',
			// 		title: '用户中心',
			// 	},
			// 	children: [
			// {
			// 	path: '/user-manage',
			// 	component: () => import('@/views/user/userManage.vue'),
			// 	class: 'icon-a-yingmuzhibohuodongtongzhi1',
			// 	name: 'user.userManage',
			// 	crumb: '用户管理',
			// 	title: '用户管理',

			// 	meta: {
			// 		code: 40,
			// 		crumb: '用户管理',
			// 		title: '用户管理',
			// 	},
			// },
			// {
			// 	path: '/event-notice',
			// 	component: () => import('@/views/user/eventNotice.vue'),
			// 	class: 'icon-a-yingmuzhibohuodongtongzhi1',
			// 	name: 'user.eventNotice',
			// 	crumb: '活动通知',
			// 	title: '活动通知',

			// 	meta: {
			// 		code: 41,
			// 		crumb: '活动通知',
			// 		title: '活动通知',
			// 	},
			// },
			// {
			// 	path: '/sensitive',
			// 	name: 'user.sensitive',
			// 	component: () => import('@/views/user/sensitive.vue'),
			// 	class: 'icon-zidingyiminganciku',
			// 	crumb: '敏感词库',
			// 	title: '敏感词库',

			// 	meta: {
			// 		code: 42,
			// 		crumb: '敏感词库',
			// 		title: '敏感词库',
			// 	},
			// },
			// {
			// 	path: '/labelManage',
			// 	name: 'user.labelManage',
			// 	component: () => import('@/views/user/labelManage.vue'),
			// 	class: 'icon-zidingyiminganciku', //next
			// 	crumb: '标签管理',
			// 	title: '标签管理',
			// 	meta: {
			// 		code: 43,
			// 		crumb: '标签管理',
			// 		title: '标签管理',
			// 	},
			// },
			// {
			// 	path: '/reviewManage',
			// 	name: 'user.reviewManage',
			// 	component: () => import('@/views/user/reviewManage/index.vue'),
			// 	// class: 'icon-zidingyiminganciku', //next
			// 	crumb: '评论管理',
			// 	title: '评论管理',
			// 	meta: {
			// 		code: 44,
			// 		crumb: '评论管理',
			// 		title: '评论管理',
			// 	},
			// },
			// 	],
			// },
			{
				path: '/statistics',
				component: () => {
					return import('@/views/user/statistics');
				},
				class: 'icon-a-7shujuzhongxin',
				name: 'user.statistics',
				crumb: '数据中心',
				title: '数据中心',
				meta: {
					code: 8,
					title: '数据中心',
					crumb: '数据中心',
				},
			},
			{
				path: 'privateMall',
				class: 'icon-a-8shangcheng',
				name: 'user.privateMall',
				title: '私域电商',
				line: true,
				children: [
					// {
					// 	path: 'management',
					// 	class: 'icon-a-8shangcheng',
					// 	name: 'user.privateMall.management',
					// 	title: '连锁门店',
					// 	upgrade: 'user',
					// 	upgradePayType: 4,
					// 	link: privateMallUrl,
					// 	marketing: 'user.marketing.privatemall',
					// 	meta: {
					// 		crumb: '连锁门店',
					// 	},
					// },
					{
						path: 'mall',
						class: 'icon-a-8shangcheng',
						name: 'user.myMall',
						title: '我的商城',
						link: emallUrl,
						upgrade: 'user',
						upgradePayType: 2,
						meta: {
							crumb: '我的商城',
							code: 9,
							childrenCode: [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
						},
					},
				],
			},
			// {
			// 	path: '/reserve',
			// 	component: () => import('@/views/user/reserve.vue'),
			// 	name: 'user.reserve',
			// 	title: '找执行',
			// 	link: 'https://h-pai.com/?channel=live',
			// 	meta: {
			// 		code: 7,
			// 	},
			// },
			{
				path: '/income',
				component: () => import('@/views/user/myIncomeV2/index.vue'),
				class: 'icon-a-9wodezichan',
				name: 'user.income',
				crumb: '我的资产',
				title: '我的资产',
				redirect: '/income/profit',

				meta: {
					code: 10,
					title: '我的资产',
					crumb: '我的资产',
				},
				children: [
					// {
					// 	path: 'profit',
					// 	component: () => import('@/views/user/myIncomeV2/profit'),
					// 	name: 'user.income.profit',
					// 	crumb: '钱包收益',
					// 	title: '钱包收益',
					// 	meta: {
					// 		code: 60,
					// 		title: '钱包收益',
					// 		crumb: '我的资产',
					// 	},
					// 	redirect: { name: 'user.income.profit.walletBill' },
					// 	children: [
					// 		{
					// 			path: 'walletBill',
					// 			component: () => import('@/views/user/myIncomeV2/profit/walletBill.vue'),
					// 			name: 'user.income.profit.walletBill',
					// 			crumb: '我的资产',
					// 			meta: {
					// 				title: '钱包收益',
					// 				crumb: '我的资产',
					// 				parentName: 'user.income.profit',
					// 			},
					// 		},
					// 		{
					// 			path: 'profitBill',
					// 			component: () => import('@/views/user/myIncomeV2/profit/profitBill.vue'),
					// 			name: 'user.income.profit.profitBill',
					// 			crumb: '我的资产',
					// 			meta: {
					// 				title: '钱包收益',
					// 				crumb: '我的资产',
					// 				parentName: 'user.income.profit',
					// 			},
					// 		},
					// 		{
					// 			path: 'marketingBill',
					// 			component: () => import('@/views/user/myIncomeV2/profit/marketingBill.vue'),
					// 			name: 'user.income.profit.marketingBill',
					// 			crumb: '我的资产',
					// 			meta: {
					// 				title: '钱包收益',
					// 				crumb: '我的资产',
					// 				parentName: 'user.income.profit',
					// 			},
					// 		},
					// 	],
					// },
					{
						path: 'sms',
						component: () => import('@/views/user/myIncomeV2/sms'),
						name: 'user.income.sms',
						crumb: '短信资产',
						title: '短信资产',

						meta: {
							code: 61,
							title: '短信资产',
							crumb: '短信资产',
						},
					},
					// {
					// 	path: 'coupon',
					// 	component: () => import('@/views/user/myIncomeV2/coupon.vue'),
					// 	name: 'user.income.coupon',
					// 	crumb: '优惠券',
					// 	title: '优惠券',

					// 	meta: {
					// 		code: 62,
					// 		title: '优惠券',
					// 		crumb: '优惠券',
					// 	},
					// },
					{
						path: 'sms-accets',
						component: () => import('@/views/user/myIncomeV2/smsAccets.vue'),
						name: 'user.income.smsAccets',
						hidden: true,
						crumb: '短信资产统计',
						title: '短信资产统计',
						meta: {
							title: '短信资产统计',
							crumb: '短信资产统计',
						},
					},
				],
			},
			// {
			// 	path: '/invoice',
			// 	class: 'icon-a-10dingdanfapiao',
			// 	name: 'user.invoice',
			// 	crumb: '订单发票',
			// 	title: '订单发票',

			// 	meta: {
			// 		code: 11,
			// 		title: '订单发票',
			// 		crumb: '订单发票',
			// 	},
			// 	link: myOrderUrl,
			// },
			// {
			// 	path: '/notice',
			// 	class: 'icon-a-11xitongtongzhi',
			// 	name: 'notice',
			// 	crumb: 'user.notice',
			// 	title: '系统通知',
			// 	line: true,

			// 	meta: {
			// 		code: 12,
			// 		title: '系统通知',
			// 		crumb: '系统通知',
			// 	},
			// 	component: () => import('@/views/notice/noticeLive'),
			// 	redirect: {
			// 		name: 'user.notice.list',
			// 	},
			// 	children: [
			// 		{
			// 			path: 'list',
			// 			component: () => import('@/components/noticeManage.vue'),
			// 			name: 'user.notice.list',
			// 			crumb: '系统消息',
			// 			meta: {
			// 				title: '公告列表',
			// 				crumb: '系统消息',
			// 				parentName: 'notice',
			// 			},
			// 			hidden: true,
			// 		},
			// 		{
			// 			path: 'detail/:noticeId',
			// 			component: () => import('@/components/noticeManageDetail.vue'),
			// 			name: 'user.notice.detail',
			// 			crumb: '系统消息',
			// 			meta: {
			// 				title: '详细公告',
			// 				crumb: '系统消息',
			// 				parentName: 'notice',
			// 			},
			// 			hidden: true,
			// 		},
			// 	],
			// },
			{
				path: '/companyMode',
				component: () => import('@/views/user/companyMode'),
				name: 'companyManage',
				title: '企业管理',
				class: 'icon-a-12qiyeguanli',

				meta: {
					code: 13,
					title: '企业管理',
					crumb: '企业管理',
				},
				redirect: { name: 'user.subaccount' },
				children: [
					{
						path: '/information',
						component: () => import('@/views/user/information'),
						name: 'user.information',
						class: 'icon-gerenxinxi',
						crumb: '个人信息',
						title: '个人信息',
						meta: {
							title: '个人信息',
							crumb: '个人信息',
							parentName: 'companyManage',
						},
						hidden: true,
						redirect: {
							name: 'information.basic',
						},
						children: [
							{
								path: 'basic',
								name: 'information.basic',
								component: () => import('@/views/user/information/basic'),
								meta: {
									parentName: 'user.information',
									icon: 'icon-jibenziliao',
									title: '基本资料',
									crumb: '基本资料',
								},
							},
							{
								path: 'configGlobal',
								name: 'information.configGlobal',
								component: () => import('@/views/user/information/configGlobal'),
								meta: {
									parentName: 'user.information',
									icon: 'icon-quanjupeizhi',
									title: '全局配置',
									crumb: '全局配置',
								},
							},
							{
								path: 'domain',
								name: 'information.domain',
								component: () => import('@/views/user/information/domain'),
								meta: {
									parentName: 'user.information',
									icon: 'icon-yumingxinxi',
									title: '域名信息',
									crumb: '域名信息',
								},
							},
							{
								path: 'subscription',
								name: 'information.subscription',
								component: () => import('@/views/user/information/subScription'),
								meta: {
									parentName: 'user.information',
									icon: 'icon-gongzhonghaoshezhi',
									title: '公众号设置',
									crumb: '公众号设置',
								},
							},
							{
								path: 'wechatPay',
								name: 'information.wechatPay',
								component: () => import('@/views/user/information/wechatPay'),
								meta: {
									parentName: 'user.information',
									icon: 'icon-weixinzhifutongdaopeizhi',
									title: '微信支付通道配置',
									crumb: '微信支付通道配置',
								},
							},
						],
					},
					{
						path: '/subaccount',
						component: () => import('@/views/user/account'),
						name: 'user.subaccount',
						class: 'icon-zizhanghaoshezhi',
						crumb: '子账号设置',
						title: '子账号设置',
						tagType: 'company',
						isCompany: 1,

						meta: {
							code: 63,
							title: '子账号设置',
							crumb: '子账号设置',
						},
					},

					{
						path: '/serviceAccess',
						component: () => import('@/views/user/advanced/serviceAccess'),
						name: 'user.advanced.serviceAccess',
						class: 'icon-gerenzhongxin',
						crumb: '第三方服务接入',
						title: '第三方服务接入',

						meta: {
							code: 64,
							title: '第三方服务接入',
							crumb: '第三方服务接入',
							parentName: 'companyManage',
						},
						// children: [
						// 	{
						// 		path: 'serviceAccess',
						// 		name: 'advanced.serviceAccess',
						// 		crumb: '高级设置',
						// 		title: '高级设置',
						// 		component: () => import('@/views/user/advanced/serviceAccess'),
						// 		meta: {
						// 			parentName: 'user.advanced',
						// 			icon: 'icon-jibenziliao',
						// 			title: '服务接入',
						// 			crumb: '高级设置',
						// 		},
						// 	},
						// 	{
						// 		path: 'configGlobal',
						// 		name: 'advanced.configGlobal',
						// 		component: () => import('@/views/user/advanced/configGlobal'),
						// 		crumb: '高级设置',
						// 		title: '高级设置',
						// 		meta: {
						// 			parentName: 'user.advanced',
						// 			icon: 'icon-quanjupeizhi',
						// 			title: '全局配置',
						// 			crumb: '高级设置',
						// 		},
						// 	},
						// 	{
						// 		path: 'operateLog',
						// 		name: 'advanced.operateLog',
						// 		crumb: '高级设置',
						// 		title: '高级设置',
						// 		meta: {
						// 			parentName: 'user.advanced',
						// 			icon: 'icon-shezhi',
						// 			title: '操作日志',
						// 			crumb: '高级设置',
						// 		},
						// 		component: () => import('@/views/user/advanced/operateLog'),
						// 	},
						// ],
					},
					{
						path: '/configGlobal',
						component: () => import('@/views/user/advanced/configGlobal/index.vue'),
						name: 'user.advanced.configGlobal',
						class: 'icon-gerenzhongxin',
						crumb: '品牌及全局设置',
						title: '品牌及全局设置',
						tagType: 'company',
						isCompany: 1,
						meta: {
							code: 65,
							title: '品牌及全局设置',
							crumb: '品牌及全局设置',
							parentName: 'companyManage',
						},
						redirect: { name: 'user.advanced.configGlobal.companyLogo' },
						children: [
							{
								path: 'companyLogo',
								name: 'user.advanced.configGlobal.companyLogo',
								crumb: '品牌及全局设置',
								title: '品牌及全局设置',
								meta: {
									parentName: 'user.advanced',
									icon: 'icon-shezhi',
									title: '企业logo设置',
									crumb: '品牌及全局设置',
								},
								component: () => import('@/views/user/advanced/configGlobal/companyLogo.vue'),
							},
							{
								path: 'companyLive',
								name: 'user.advanced.configGlobal.companyLive',
								crumb: '品牌及全局设置',
								title: '品牌及全局设置',
								meta: {
									parentName: 'user.advanced',
									icon: 'icon-shezhi',
									title: '直播间品牌设置',
									crumb: '品牌及全局设置',
								},
								component: () => import('@/views/user/advanced/configGlobal/companyLive.vue'),
							},
							{
								path: 'publish',
								name: 'user.advanced.configGlobal.publish',
								crumb: '品牌及全局设置',
								title: '品牌及全局设置',
								meta: {
									parentName: 'user.advanced',
									icon: 'icon-shezhi',
									title: '推流设置',
									crumb: '品牌及全局设置',
								},
								component: () => import('@/views/user/advanced/configGlobal/publish.vue'),
							},
						],
					},
					{
						path: '/operateLog',
						component: () => import('@/views/user/advanced/operateLog'),
						name: 'user.advanced.operateLog',
						class: 'icon-gerenzhongxin',
						crumb: '操作日志',
						title: '操作日志',

						meta: {
							code: 66,
							title: '操作日志',
							crumb: '操作日志',
							parentName: 'companyManage',
						},
					},
					{
						path: '/officialAccount',
						name: 'serviceAccess.officialAccount',
						crumb: '第三方服务接入',
						title: '第三方服务接入',
						meta: {
							title: '第三方服务接入',
							crumb: '第三方服务接入',
							parentName: 'user.advanced.serviceAccess',
						},
						hidden: true,
						component: () => import('@/views/user/officialAccount'),
					},
					{
						path: '/accessInfo',
						name: 'serviceAccess.accessInfo',
						crumb: '第三方服务接入',
						title: '第三方服务接入',
						meta: {
							title: '第三方服务接入',
							crumb: '第三方服务接入',
							parentName: 'user.advanced.serviceAccess',
						},
						hidden: true,
						component: () => import('@/views/user/accessInfo'),
					},
					{
						path: '/serviceAccount',
						name: 'serviceAccess.serviceAccount',
						crumb: '第三方服务接入',
						title: '第三方服务接入',
						meta: {
							title: '第三方服务接入',
							crumb: '第三方服务接入',
							parentName: 'user.advanced.serviceAccess',
						},
						hidden: true,
						component: () => import('@/views/user/serviceAccount'),
					},
					{
						path: '/applyAccount',
						name: 'serviceAccess.applyAccount',
						crumb: '高级设置',
						title: '高级设置',
						meta: {
							title: '高级设置',
							crumb: '高级设置',
							parentName: 'companyManage',
						},
						hidden: true,
						component: () => import('@/views/user/serviceAccount/applyAccount.vue'),
						redirect: {
							name: 'serviceAccess.applyInfo',
						},
						children: [
							// 填写申请信息
							{
								path: '/applyAccount/applyInfo/:id?',
								name: 'serviceAccess.applyInfo',
								meta: {
									title: '高级设置',
									crumb: '高级设置',
									parentName: 'user.advanced',
								},
								component: () => import('@/views/user/serviceAccount/applyInfo.vue'),
							},
							// 账户验证
							{
								path: '/applyAccount/accountCheck',
								name: 'serviceAccess.accountCheck',
								meta: {
									title: '高级设置',
									crumb: '高级设置',
									parentName: 'user.advanced',
								},
								component: () => import('@/views/user/serviceAccount/accountCheck.vue'),
							},
							// 签约
							{
								path: '/applyAccount/signContract:id',
								name: 'serviceAccess.signContract',
								meta: {
									title: '高级设置',
									crumb: '高级设置',
									parentName: 'user.advanced',
								},
								component: () => import('@/views/user/serviceAccount/signContract.vue'),
							},
							// 开通成功
							{
								path: '/applyAccount/openSuccess/:id',
								name: 'serviceAccess.openSuccess',
								meta: {
									title: '高级设置',
									crumb: '高级设置',
									parentName: 'user.advanced',
								},
								component: () => import('@/views/user/serviceAccount/openSuccess.vue'),
							},
						],
					},
					{
						path: '/commerBridge',
						name: 'serviceAccess.commerBridge',
						crumb: '第三方服务接入',
						title: '第三方服务接入',
						meta: {
							title: '第三方服务接入',
							crumb: '第三方服务接入',
							parentName: 'user.advanced.serviceAccess',
						},
						hidden: true,
						component: () => import('@/views/user/advanced/commerBridge'),
					},
				],
			},
			{
				path: '/workwechat',
				component: () => import('@/views/user/workwechat.vue'),
				name: 'user.workwechat',
				crumb: '企业微信',
				title: '企业微信',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					crumb: '企业微信',
					title: '企业微信',
				},
			},
			{
				path: '/reward',
				component: () => import('@/views/user/jackpot/myReward.vue'),
				class: 'icon-jiangchitiku1',
				name: 'user.reward',
				crumb: '奖池/题库',
				title: '奖池/题库',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					crumb: '奖池/题库',
					title: '奖池/题库',
				},
			},
			{
				path: '/question/add',
				component: () => import('@/views/user/jackpot/questionForm.vue'),
				class: 'icon-jiangchitiku1',
				name: 'user.question.add',
				crumb: '添加题目',
				title: '添加题目',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					crumb: '添加题目',
					title: '添加题目',
				},
			},
			{
				path: '/question/editor/:id',
				component: () => import('@/views/user/jackpot/questionForm.vue'),
				class: 'icon-jiangchitiku1',
				name: 'user.question.editor',
				crumb: '编辑题目',
				title: '编辑题目',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					crumb: '编辑题目',
					title: '编辑题目',
				},
			},
			{
				path: 'questionnaire',
				// class: 'icon-wenjuantiaocha',
				name: 'user.questionnaire',
				crumb: '问卷/投票',
				title: '问卷/投票',
				hidden: true,
				link: questionUrl,
				meta: {
					parentName: 'user.marketing',
					crumb: '问卷/投票',
					title: '问卷/投票',
				},
			},
			{
				path: 'invitefree/:id',
				name: 'invitefreedesc',
				component: () => import('@/views/user/freeAfterInvitation/invitefreedesc.vue'),
				title: '邀请好友免单',
				crumb: '邀请好友免单',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '邀请好友免单',
					crumb: '邀请好友免单',
				},
			},
			{
				path: 'invitefree',
				name: 'invitefree',
				title: '邀请好友免单',
				crumb: '邀请好友免单',
				component: () => import('@/views/user/freeAfterInvitation/invitefree.vue'),
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '邀请好友免单',
					crumb: '邀请好友免单',
				},
			},
			{
				path: '/reward/detail/:id',
				component: () => import('@/views/user/jackpot/rewardDetail.vue'),
				class: 'icon-rewardDetail',
				name: 'user.rewardDetail',
				crumb: '奖池/题库',
				title: '奖池/题库',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					crumb: '奖池/题库',
					title: '奖池/题库',
				},
			},
			{
				path: '/invitereward',
				component: () => import('@/views/user/invitereward/index.vue'),
				redirect: { name: 'user.invitereward.index' },
				class: 'icon-invitereward',
				name: 'user.invitereward',
				crumb: '邀请奖励',
				title: '邀请奖励',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					crumb: '邀请奖励',
					title: '邀请奖励',
				},
				children: [
					{
						path: 'index',
						component: () => import('@/views/user/invitereward/_index.vue'),
						name: 'user.invitereward.index',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							crumb: '邀请奖励',
							title: '邀请奖励',
						},
					},
					{
						path: 'addNew',
						component: () => import('@/views/user/invitereward/add-new.vue'),
						name: 'user.invitereward.addnew',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							crumb: '邀请奖励',
							title: '邀请奖励',
						},
					},
					{
						path: 'participation/:id',
						component: () => import('@/views/user/invitereward/participation.vue'),
						name: 'user.invitereward.participation',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							crumb: '邀请奖励',
							title: '邀请奖励',
						},
					},
					{
						path: 'invitations/:id/:userId',
						component: () => import('@/views/user/invitereward/invitations.vue'),
						name: 'user.invitereward.invitations',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							crumb: '邀请奖励',
							title: '邀请奖励',
						},
					},
				],
			},
			{
				path: '/blindBox',
				component: () => import('@/views/user/blindBox/index.vue'),
				class: 'icon-manghe1',
				name: 'user.blindBox',
				hidden: true,
				title: '盲盒',
				crumb: '盲盒',
				redirect: {
					name: 'user.boxList',
				},
				meta: {
					parentName: 'user.marketing',
					title: '盲盒',
					crumb: '盲盒',
				},
				children: [
					{
						path: 'boxList',
						name: 'user.boxList',
						component: () => import('@/views/user/blindBox/boxList.vue'),
						title: '盲盒',
						crumb: '盲盒',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '盲盒',
							crumb: '盲盒',
						},
					},
					{
						path: 'createBlindBox',
						name: 'user.createBlindBox',
						component: () => import('@/views/user/blindBox/createBlindBox'),
						title: '盲盒',
						crumb: '盲盒/创建盲盒',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '盲盒',
							crumb: '盲盒/创建盲盒',
						},
					},
					{
						path: 'boxSet',
						name: 'user.boxSet',
						component: () => import('@/views/user/blindBox/boxSet'),
						title: '盲盒',
						crumb: '盲盒/创建盲盒',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '盲盒',
							crumb: '盲盒/创建盲盒',
						},
					},
					{
						path: 'buyInfoList/:id',
						name: 'user.buyInfoList',
						component: () => import('@/views/user/blindBox/buyInfoList'),
						title: '盲盒',
						crumb: '盲盒/购买详情',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '盲盒',
							crumb: '盲盒/购买详情',
						},
					},
				],
			},
			{
				path: '/socialSquare',
				component: () => import('@/views/user/socialSquare/index.vue'),
				class: 'icon-shejiaoguagnchang',
				name: 'user.socialSquare',
				hidden: true,
				title: '社交广场',
				crumb: '社交广场',
				redirect: {
					name: 'user.businessCard',
				},
				meta: {
					parentName: 'user.marketing',
					title: '社交广场',
					crumb: '社交广场',
				},
				children: [
					{
						path: '/businessCard',
						name: 'user.businessCard',
						component: () => import('@/views/user/socialSquare/businessCard.vue'),
						title: '名片广场',
						crumb: '名片广场',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '名片广场',
							crumb: '名片广场',
						},
					},
					{
						path: '/communication',
						name: 'user.communication',
						component: () => import('@/views/user/socialSquare/communication.vue'),
						title: '一对一交流',
						crumb: '一对一交流',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '一对一交流',
							crumb: '一对一交流',
						},
					},
				],
			},
			{
				path: 'communityFission',
				name: 'user.communityFission',
				component: () => import('@/views/user/communityFission/index.vue'),
				title: '社群裂变',
				crumb: '社群裂变',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '社群裂变',
					crumb: '社群裂变',
				},
				redirect: {
					name: 'user.communityFission.list',
				},
				children: [
					{
						path: 'guide',
						name: 'user.communityFission.guide',
						component: () => import('@/views/user/communityFission/guide.vue'),
						title: '社群裂变',
						crumb: '社群裂变',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '社群裂变',
							crumb: '社群裂变',
						},
					},
					{
						path: 'list',
						name: 'user.communityFission.list',
						component: () => import('@/views/user/communityFission/list.vue'),
						title: '社群裂变',
						crumb: '营销中心/社群裂变',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '社群裂变',
							crumb: '营销中心/社群裂变',
						},
					},
					{
						path: 'create',
						name: 'user.communityFission.create',
						component: () => import('@/views/user/communityFission/create.vue'),
						title: '社群裂变',
						crumb: '营销中心/社群裂变',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '社群裂变',
							crumb: '营销中心/社群裂变',
						},
					},
					{
						path: 'data/:id',
						name: 'user.communityFission.data',
						component: () => import('@/views/user/communityFission/data.vue'),
						title: '社群裂变',
						crumb: '营销中心/社群裂变',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '社群裂变',
							crumb: '营销中心/社群裂变',
						},
					},
					{
						path: 'setting/:id/:groupId',
						name: 'user.communityFission.setting',
						component: () => import('@/views/user/communityFission/setting.vue'),
						title: '社群裂变',
						crumb: '营销中心/社群裂变',
						hidden: true,
						meta: {
							parentName: 'user.marketing',
							title: '社群裂变',
							crumb: '营销中心/社群裂变',
						},
					},
				],
			},
			{
				path: 'multimediaBroadcast',
				name: 'user.multimediaBroadcast',
				component: () => import('@/views/user/multimediaBroadcast/index.vue'),
				title: '多媒体联播',
				crumb: '多媒体联播',
				hidden: true,
				meta: {
					parentName: 'user.marketing',
					title: '多媒体联播',
					crumb: '多媒体联播',
				},
			},
		],
	},
];
